
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import StageBaseController from '../stage-base.controller';

import ship_bg from '../../../assets/images/intro/intro-bg-4.png';

export default class MainController extends StageBaseController{
    constructor($log, $rootScope, $state, Session, Dialog) {
        'ngInject';
        super($log, $state, Session);
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.Session = Session;
        this.Dialog = Dialog;
        this.stages = "";

        this.ship_bg = ship_bg;

        this.state = {
            step: 0
        }

        this.finalDialogs = [
            { bg: this.ship_bg, dialog: "Parabéns, humano! Agora você pode viajar até o <strong>planeta Tetrix</strong>!", direction: "out" }, 
            { bg: this.ship_bg, dialog: "Para isto, basta colocar as <strong>três chaves</strong> nas fechaduras correspondentes do <strong>tetraedro</strong>.", direction: "out" }
        ]
    }

    $onInit(){
        let data = this.Session.get();
        
        if (!_.isEmpty(data)){
            this.stages = this.Session.get().stages;
            this.keys = this.Session.getKeys();
        }    
    }

    keysCheck(){
        if ((this.keys[0] === true) && (this.keys[1] === true) && (this.keys[2] === true)){
            return true;
        }
    }

    nextStep(){
        let $ctrl = this;
        if($ctrl.state.step < $ctrl.finalDialogs.length - 1){
            $ctrl.state.step++;
        } else {
            $ctrl.redirectToEnd();
        }
    }

    redirectToEnd(){
        this.$state.go('tetraedro');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js